<template>
  <div v-loading="isFetchingAccounts">
    <Selector
      class="analytics-account-selector"
      required
      title="Выберите аккаунт"
      isMulti
      hasSearch
      showSelectAll
      style="--options-container-max-height: 40rem"
      :key="`analytics-account-selector-key-${this.selectedServices.length}`"
      :disabled="!selectedServices.length || selectedServices.length > 1"
      limitOptionsHeight
      :options="serviceOptions"
      :value="selectedAccounts"
      :select-fitrst-item="false"
      @onChange="debouncedHandleSelectorChange"
    />
  </div>
</template>

<script>
import Selector from '@/components/sort/Selector';
import { AnalyticsType } from '@/utils/common';
import { debounce } from '@/utils/helpers';

export default {
  name: 'AnalyticsAccountSelector',
  components: {
    Selector,
  },
  data() {
    return {
      accounts: [],
      isFetchingAccounts: false,
      // debouncedFetchAccounts: null, // Будет хранить debounce-функцию
      // debouncedFetchAnalytics: null,
      debouncedHandleSelectorChange: null,
    };
  },
  created() {
    // this.debouncedFetchAccounts = debounce(this.fetchAccounts, 500);
    // this.debouncedFetchAnalytics = debounce(this.fetchAnalytics, 1000);
    this.debouncedHandleSelectorChange = debounce(this.handleSelectorChange, 1000);
  },
  computed: {
    analyticsAccountSelectorKey() {
      return 'analytics-account-selector-key-' + this.selectedServices.length;
    },
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
    previousAccountsData() {
      return this.$store.state.Analytics[AnalyticsType.ADVANCED].previousAccountsData || [];
    },
    serviceOptions() {
      if (this.previousAccountsData) {
        // Собираем все аккаунты из всех сервисов
        const arr = [];
        Object.keys(this.previousAccountsData).forEach((key) => {
          arr.push(...this.previousAccountsData[key]);
        });
        // Оставляем только уникальные по id (и name, если id нет)
        const uniqueMap = new Map();
        arr.forEach((item) => {
          if (item.id && !uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, { id: item.id, name: item.name });
          }
        });
        // Добавим аккаунты без id, но с уникальным name
        arr.forEach((item) => {
          if (!item.id && item.name && ![...uniqueMap.values()].find((i) => i.name === item.name)) {
            uniqueMap.set(`name:${item.name}`, { id: null, name: item.name });
          }
        });
        return Array.from(uniqueMap.values());
      } else {
        return [];
      }
    },
    selectedAccounts() {
      return [...this.$store.state.Analytics[AnalyticsType.ADVANCED].selectedAccounts];
    },
    selectedServices() {
      return [...this.$store.state.Analytics[AnalyticsType.ADVANCED].selectedServices];
    },
  },
  methods: {
    handleSelectorChange(accounts) {
      this.$store.commit('Analytics/changeSelectedCompanies', []);
      this.$store.commit('Analytics/changeSelectedAccounts', [...accounts]);
      this.$store.commit('Analytics/resetPreviousCompaniesData');
      this.fetchAnalytics();
    },
    async fetchAnalytics() {
      if (this.selectedAccounts.length === 1) {
        try {
          this.$store.commit('Analytics/toggleLoading', {
            value: true,
            type: AnalyticsType.ADVANCED,
          });
          await this.$store.dispatch('Analytics/getAdvancedAnalytics', this.activeAccount.id);
        } catch (e) {
          console.error('Failed to fetch analytics:', e);
        } finally {
          this.$store.commit('Analytics/toggleLoading', {
            value: false,
            type: AnalyticsType.ADVANCED,
          });
        }
      }
    },
    // async fetchAccounts() {
    //   if (!this.selectedServices.length || this.selectedServices.length > 1) {
    //     this.accounts = [];
    //     return;
    //   }

    //   this.isFetchingAccounts = true;

    //   try {
    //     const response = await this.$store.dispatch('Ad/getAccounts', {
    //       service: this.selectedServices[0], // Берем первый (и единственный) выбранный сервис
    //       business_account_id: this.activeAccount.id,
    //       per_page: 1000
    //     });

    //     this.accounts = response.data;
    //   } catch(e) {
    //     console.error('Failed to fetch accounts,', e);
    //     this.accounts = [];
    //   } finally {
    //     this.isFetchingAccounts = false;
    //   }
    // }
  },
  watch: {
    selectedServices() {
      // this.debouncedFetchAccounts();
    },
  },
};
</script>
